import { Grid, useMediaQuery } from "@mui/material";
import { FunctionField, Labeled, ReferenceField, TextField } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { accountRequests } from "api/accountApi";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";

const StudentInfoSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        title="Информация за студента"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Студент">
            <ReferenceField
              reference={accountRequests.getUsersSelect()}
              source="userId"
            >
              <FunctionField
                render={rec =>
                  rec.secondName
                    ? `${rec.firstName} ${rec.secondName} ${rec.lastName}`
                    : `${rec.firstName} ${rec.lastName}`
                }
              />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Факултетен номер">
            <TextField source="facultyNumber" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Специалност">
            <ReferenceField
              source="specialityId"
              reference={administrationRequests.getSpecialitiesSelect()}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default StudentInfoSection;
